const shareButtonSelector = '[data-share-button]';
const shareGroupSelector = '[data-share-buttons]';

const pushBase = 4;

const resetButtons = (buttons) => {
    buttons.forEach((button) => {
        button.classList.remove('is-left', 'is-right', 'is-hovered');
        button.style.removeProperty('--share-push');
    });
};

const applyDisplacement = (buttons, hoveredIndex) => {
    buttons.forEach((button, index) => {
        if (index === hoveredIndex) {
            button.classList.add('is-hovered');
            button.style.removeProperty('--share-push');
            return;
        }

        const distance = Math.abs(index - hoveredIndex) || 1;
        const pushDistance = `${distance * pushBase}px`;

        button.classList.remove('is-hovered');
        button.classList.add(index < hoveredIndex ? 'is-left' : 'is-right');
        button.style.setProperty('--share-push', pushDistance);
    });
};

const mountShareGroup = (group) => {
    const buttons = Array.from(group.querySelectorAll(shareButtonSelector));
    if (buttons.length === 0) {
        return;
    }

    const resetGroup = () => resetButtons(buttons);

    group.addEventListener('mouseleave', resetGroup);

    buttons.forEach((button, index) => {
        button.addEventListener('mouseenter', () => {
            resetButtons(buttons);
            applyDisplacement(buttons, index);
        });

        button.addEventListener('focus', () => {
            resetButtons(buttons);
            applyDisplacement(buttons, index);
        });

        button.addEventListener('blur', () => {
            window.requestAnimationFrame(() => {
                if (!group.contains(document.activeElement)) {
                    resetGroup();
                }
            });
        });
    });
};

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(shareGroupSelector).forEach(mountShareGroup);
});
